/**
 * Events
 */
/**
 * A helper class Hubs can derive from to implement support for MetaOs Events
 * in MetaOs Services.
 */
var EventService = /** @class */ (function () {
    function EventService() {
        this.registrations = new Map();
    }
    EventService.prototype.addEventListener = function (type, listener) {
        this.registrations.set(type, listener);
    };
    EventService.prototype.dispatchEvent = function (type, e) {
        if (this.registrations.has(type)) {
            this.registrations.get(type)(e);
        }
    };
    EventService.prototype.clearListeners = function () {
        this.registrations.clear();
    };
    return EventService;
}());
export { EventService };
//# sourceMappingURL=hosted-web-content-sdk-services.events.js.map